import Vue from 'vue';
import mutations from './mutationTypes';

export default {
  [mutations.setList](state, { list }) {
    Vue.set(state, 'list', list);
  },

  [mutations.setEntity](state, { entity }) {
    if (entity == null || typeof entity !== 'object' || entity._id == null) {
      return;
    }

    const index = state.list.findIndex(({ _id }) => entity._id === _id);
    state.list.splice(index, index >= 0 ? 1 : 0, entity);
  },

  [mutations.deleteEntity](state, { id }) {
    state.list = state.list.filter(({ _id }) => _id !== id);
  },

  [mutations.deleteEntityByCompanyId](state, { companyId }) {
    state.list = state.list.filter((item) => item.companyId !== companyId);
  },

  [mutations.setEntityRevId](state, { id, revId }) {
    const entity = state.list.find(({ _id }) => _id === id);
    if (entity != null) {
      Vue.set(entity, '_rev', revId);
    }
  },

  [mutations.setProjectFile](state, { id, projectId, fileEntry, updateId }) {
    const entity = state.list.find(({ _id }) => _id === id);
    if (entity.projectFiles == null) {
      Vue.set(entity, 'projectFiles', {});
    }

    if (entity.projectFiles[projectId] == null || entity.projectFiles[projectId].files == null) {
      Vue.set(entity.projectFiles, projectId, { files: [] });
    }

    const index = entity.projectFiles[projectId].files.findIndex(({ fileName }) => fileName === fileEntry.fileName);
    entity.projectFiles[projectId].files.splice(index, index >= 0 ? 1 : 0, { ...fileEntry, updateId });
  },

  [mutations.setProjectCodeOfConductStatus](state, { id, projectId, codeOfConduct }) {
    const entity = state.list.find(({ _id }) => _id === id);
    if (entity.projectFiles == null) {
      Vue.set(entity, 'projectFiles', {});
    }

    if (entity.projectFiles[projectId] == null || entity.projectFiles[projectId].files == null) {
      Vue.set(entity.projectFiles, projectId, { files: [], codeOfConduct });
    } else {
      entity.projectFiles[projectId].codeOfConduct = codeOfConduct;
    }
  },

  [mutations.revertProjectFileUpdate](state, { id, projectId, updateId, prevFileEntry }) {
    const entity = state.list.find(({ _id }) => _id === id);
    if (
      entity.projectFiles == null ||
      entity.projectFiles[projectId] == null ||
      entity.projectFiles[projectId].files == null
    ) {
      return;
    }

    const index = entity.projectFiles[projectId].files.findIndex((item) => item.updateId === updateId);
    if (index >= 0) {
      entity.projectFiles[projectId].files.splice(index, 1, prevFileEntry ? { ...prevFileEntry } : undefined);
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/companyFiles/mutations.js